export default {
  methods: {
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
    getEventDate(blockStartDate, currentDay ) {
      let startDate = this.$moment(blockStartDate, "YYYY-MM-DD");
      let eventDate = startDate.add(currentDay - 1, 'days');
      return eventDate.format("YYYY-MM-DD");
    },
    getDateforDay(day, anchorDate) {
      let date = this.$moment(anchorDate);
      // Must be a better way? I couldn't find one.
      if (day == "Tuesday") {
        date.add(1, "days");
      }
      if (day == "Wednesday") {
        date.add(2, "days");
      }
      if (day == "Thursday") {
        date.add(3, "days");
      }
      if (day == "Friday") {
        date.add(4, "days");
      }
      if (day == "Saturday") {
        date.add(5, "days");
      }
      if (day == "Sunday") {
        date.add(6, "days");
      }
      return date;
    },
    getWorkoutBlockEvents(edges) {
      let events = [];
      
      edges.forEach((element) => {
        let subscriptionBlock = element.node;
        let endDate = this.$moment(subscriptionBlock.endDate, "YYYY-MM-DD")
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        let event = {
          id: this.getId(subscriptionBlock.block.id),
          start: subscriptionBlock.startDate,
          end: endDate,
          name: subscriptionBlock.block.title,
          type: subscriptionBlock.block.type,
          workoutBlock: subscriptionBlock,
        };
        events.push(event);
        if (subscriptionBlock.block.unitSet) {
          subscriptionBlock.block.unitSet.forEach((unitSet) => {
            unitSet.unitactivitySet.forEach((unitActivity) => {
              let eventDate = this.getEventDate(subscriptionBlock.startDate, unitActivity.currentDay);
              
              let name = "";
              if (unitActivity.type == "WORKOUT") {
                name = unitActivity.activity.title;
              } else {
                name = unitActivity.type;
              }
              let event = {
                id: unitActivity.id,
                start: eventDate,
                name: name,
                type: unitActivity.type,
              };
              events.push(event);
            });
          });
        }
      });

      return events;
    },
  },
};
